/**
 * Google Recaptcha wrapper
 *
 */

// deps
import PropTypes from 'prop-types';
import Reaptcha from 'reaptcha';

export default class CustomRecaptcha extends React.Component {
  static propTypes = {
    wrapperClassName: PropTypes.string,
  };

  static defaultProps = {
    wrapperClassName: ''
  };

  constructor() {
    super();

    const { env: isDev, isWhiteListed } = window.beaches_app;

    this.state = {
      validated: '',
      isDev,
      isWhiteListed,
    };
  }

  _onChangeHandler = (validated) => () => {
    this.setState({ validated }, () => {
      const onChangeEvent = document.createEvent('HTMLEvents');

      onChangeEvent.initEvent('change', true, true);
      const target = $('input[name="google-recaptcha"]').get(0);

      target.dispatchEvent(onChangeEvent);
    });
  };

  render() {
    const { _onChangeHandler } = this;
    const { wrapperClassName } = this.props;
    const { isDev, isWhiteListed, validated } = this.state;

    if (isDev === 'prd') {

      if (isWhiteListed === 'false') {

        return (
          <div className="row">
            <div className={`recaptcha-wrapper ${wrapperClassName}`}>
              <Reaptcha
                sitekey="6LeTYx4TAAAAAFsF8dvHY4u-WghsL_eXQMJwMEH7"
                onVerify={ _onChangeHandler('true') }
                onExpire={ _onChangeHandler('') }
              />
              <input
                type="text"
                name="google-recaptcha"
                className="hide"
                value={ validated }
                required
              />
            </div>
          </div>
        );
      }

      return <br/>;
    }

    return <br/>;
  }
}
